// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - LIST ITEM ICON ||============================== //

export default function ListItemIcon(theme: Theme) {
  return {
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 24,
          // use iconoir more options vs ant design but bit larger icons WEEPEE
          marginRight: 10,
          color: theme.palette.text.primary
        }
      }
    }
  };
}
